document.querySelectorAll('.preorder-countdown').forEach(function (el) {
  var deadline = new Date(el.dataset.deadline + 'T23:59:59');

  function setDigits(tensEl, onesEl, value) {
    var padded = String(Math.min(value, 99)).padStart(2, '0');
    tensEl.textContent = padded[0];
    onesEl.textContent = padded[1];
  }

  var daysTens = el.querySelector('[data-days-tens]');
  var daysOnes = el.querySelector('[data-days-ones]');
  var hoursTens = el.querySelector('[data-hours-tens]');
  var hoursOnes = el.querySelector('[data-hours-ones]');
  var minsTens = el.querySelector('[data-mins-tens]');
  var minsOnes = el.querySelector('[data-mins-ones]');
  var secsTens = el.querySelector('[data-secs-tens]');
  var secsOnes = el.querySelector('[data-secs-ones]');

  function tick() {
    var diff = deadline - Date.now();
    if (diff <= 0) {
      el.querySelector('.preorder-countdown__heading').textContent = 'Pre-order has closed.';
      el.querySelector('.preorder-countdown__timer').style.display = 'none';
      var btn = el.parentElement.querySelector('.product-form__submit');
      if (btn) {
        btn.disabled = true;
        btn.querySelector('span').textContent = 'Pre-order Closed';
      }
      return;
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    setDigits(daysTens, daysOnes, d);
    setDigits(hoursTens, hoursOnes, h);
    setDigits(minsTens, minsOnes, m);
    setDigits(secsTens, secsOnes, s);
  }

  tick();
  setInterval(tick, 1000);
});
